import React from 'react'
import './Styles/Footer.css'
import { HashLink } from 'react-router-hash-link'
function Footer() {
    const fc=[
        {id:1,title:"Get to Know us"},
        {id:2,title:"About us"},
        {id:3,title:"Careers"},
        {id:4,title:"Press releases"},
        {id:5,title:"Amazon Science"},
    ]
  const fc1 =[
    {id:1,title:"Connect with us"},
        {id:2,title:"facebook"},
        {id:3,title:"Twiter"},
        {id:4,title:"instagram"}
  ]
  const fc2 = [
    {id:1,title:"Make Money with Us"},
    {id:2,title:"Sell on Amazon"},
    {id:3,title:"Sell under Amazon Accelerator"},
    {id:4,title:"Protect and Build Your Brand"},
    {id:5,title:"Amazon Global Selling"},
    {id:6,title:"Become an Affiliate"},
    {id:7,title:"Fulfilment by Amazon"},
    {id:8,title:"Advertise Your Products"},
    {id:9,title:"Amazon Pay on Merchants"},
  ]
  const fc3 = [
    {id:1,title:"Let Us Help You"},
    {id:2,title:"COVID-19 and Amazon"},
    {id:3,title:"Your Account"},
    {id:4,title:"Returns Centre"},
    {id:5,title:"100% Purchase Protection"},
    {id:6,title:"Amazon App Download"},
    {id:7,title:"Help"}
  ]
  return (
   <div style={{position:"relative",bottom:'0px'}}>
    <HashLink  to='#nav1' style={{textDecorationLine:'none'}}><div className="backtotop">Back to top.</div></HashLink>
    <div className="footercontent">
   <div className="fc1">
    {fc.map((item, index)=>{
        if(item.id===1){
            return <div key={index} style={{fontWeight:'bolder'}}>{item.title}</div>
        }
        else{
            return<div key={index} className='fct'>{item.title}</div>
        }
    })}
   </div>
   <div className="fc1">
    {fc1.map((item, index)=>{
        if(item.id===1){
            return <div key={index} style={{fontWeight:'bolder'}}>{item.title}</div>
        }
        else{
            return<div key={index} className='fct' >{item.title}</div>
        }
    })}
   </div>
   <div className="fc1">
    {fc2.map((item,index)=>{
        if(item.id===1){
            return <div key={index} style={{fontWeight:'bolder'}}>{item.title}</div>
        }
        else{
            return<div key={index} className='fct'>{item.title}</div>
        }
    })}
   </div>
   <div className="fc1">
    {fc3.map((item,index)=>{
        if(item.id===1){
            return <div key={index} style={{fontWeight:'bolder'}}>{item.title}</div>
        }
        else{
            return<div key={index} className='fct'>{item.title}</div>
        }
    })}
   </div>
    </div>
   </div>
  )
}

export default Footer
